import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Container = styled.div`
    position: relative;
    height: 364px;
    max-width: 320px;
    top: -10px;
    padding: 30px 10px 12px 10px;
    margin: 10px;
    justify-content: flex-start;
    flex-direction: column;
    background-color: #20252f;
    border-radius: 32px;
`;

export const TitleWrap = styled.div`
    max-width: 274px;
    height: fit-content;
    gap: 4px;
    margin-bottom: 16px;
    margin-left: 14px;
    margin-right: 14px;
`;

export const Title = styled.span`
    color: ${COLORS.TextWhite};
    ${FONTS.H3};
`;

export const SubText = styled.span`
    color: ${COLORS.TextWhite};
    height: 32px;
    ${FONTS.XXS};
    width: 100%;
`;

export const PlankWrap = styled.div`
    gap: 8px;
`;

export const UnorderedList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    list-style: inside;
    margin-left: 14px;
    margin-right: 14px;
`;

export const Hr = styled.hr`
    height: 1px;
    width: 100%;
    border: none;
    margin: 20px 0px 0px 0px;
    background-color: ${COLORS.TextSecondary};
    color: ${COLORS.TextSecondary};
`;

export const List = styled.li`
    ${FONTS.XXS};
    color: ${COLORS.TextWhite};
    
    &::marker {
        color: ${COLORS.Logo};
    }
`;

export const Plank = styled.div`
    width: 100%;
    height: 40px;
    background-color: ${COLORS.TextSecondary};
    border-radius: 16px;
    padding: 8px 16px;
    align-items: center;
    color: ${COLORS.TextWhite};
    ${FONTS.H5};
`;

export const PriceWrap = styled.div`
    gap: 8px;
`;

export const Price = styled.span`
    color: ${COLORS.TextWhite};
    ${FONTS.H3};
`;

export const OldPrice = styled.s`
    color: ${COLORS.GRAY_DARK};
    ${FONTS.XS};
`;

export const BottomWrap = styled.div`
    position: relative;
    height: 120px;
    gap: 8px;
    display: flex;
    flex-direction: column;
    margin-bottom: 0%;
    margin-top: auto;
    margin-left: 24px;
    margin-right: 24px;
`;

export const ButtonWrap = styled.div`
    margin-bottom: 0px;
    margin-top: auto;
`;

export const Button = styled(BaseButton)<{ isActive: boolean }>`
    width: 100%;
    height: fit-content;
    color: ${COLORS.TextPrimary};
`;
